import { StepId } from '@feedyou/schema'
import { feedbotToast } from '../../../lib/feedbotToast'

export function alertInvalidTestModel(stepId: StepId) {
  return feedbotToast.error({
    title: `Cannot run test for step ${stepId}`,
    content:
      'Failed to compose an NLP model for this step. It likely resolves to an "NLP Disabled" configuration.'
  })
}
